import { Component, Input, OnInit, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { TimezoneService, Timezone } from '../../../services/timezone.service';
import { ComponentData } from '../../component-forms-container/component-forms-container.component';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DateTimeService } from '../../../services/date-time.service';
import { FontsService, Font } from '../../../services/fonts.service';
import { FilenamePipe } from '../../../pipes/filename.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth.service';
import { tap, filter } from 'rxjs/operators';
import { DM_PARAMS_DEFAULT } from '../../../data/component-templates-config';

const MINUTE_IN_SS = Number(60),
	SECOND_IN_MS = Number(1000),
	MINUTE_IN_MS = Number(MINUTE_IN_SS * SECOND_IN_MS);

const SECOND = Number(1000);
const MINUTE = Number(SECOND * 60);
const HOUR = Number(MINUTE * 60);
const DAY = Number(HOUR * 24);

@Component({
	selector: 'app-timer',
	templateUrl: './timer.component.html',
	styleUrls: ['./timer.component.scss'],
	providers: [DateTimeService]
})
export class TimerComponent implements OnInit, ComponentData, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('timerForm', { static: true }) timerForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	component;
	background_type;

	/**
	 * We need here double date obj
	 * because of ngx bootstrap (Third party library) Bootstrap
	 * Issue: on change datepicker value
	 * it resets the hours to 0
	 * so date & time is UTC time for consistent presentation
	 * for user
	 * obj time here for backup when date is set to 0 hours by bootstrap
	 * we use the old ngx bootstrap datepicker
	 * maybe in new one it's completely fixed
	 */
	date: Date;
	time: Date;
	minDate: Date = void 0;
	maxDate: Date = void 0;
	// Maximium number of days the countdown can be: maxAllowedDays
	maxAllowedDays = 31;
	minTime: Date;
	maxTime: Date;
	configOffsetTime: number;
	localOffsetTime: number;
	totalOffsetTimeMS: number;
	font;
	fontForLabel;
	date_format;
	interval;
	expImageUrl;
	expLink;
	isModalShown: Boolean = false;
	popUpLeft;
	popUpTop;
	timeFormSubscription: Subscription;
	timerPositionSubscription: Subscription;
	formScrollProp: any = {};
	timezone: string;
	timezones: Array<Timezone>;
	fonts: Array<Font>;
	imageWidth: number;
	imageHeight: number;
	random;
	newapi = false;
	isAdmin;
	dateFormatsList = [
		{ value: 'advanced', label: 'Individual Placement' },
		{ value: '%D:%H:%I:%S', label: 'dd:hh:mm:ss' },
		{ value: '%D-%H-%I-%S', label: 'dd-hh-mm-ss' },
		{ value: '%A-%I-%S', label: 'HH-mm-ss' },
		{ value: '%A:%I:%S', label: 'HH:mm:ss' },
		{ value: '%A/%I/%S', label: 'HH/mm/ss' },
		{ value: '%H-%I-%S', label: 'hh-mm-ss' },
		{ value: '%H:%I:%S', label: 'hh:mm:ss' },
		{ value: '%H/%I/%S', label: 'hh/mm/ss' }
	];
	standardDateFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	formatModalShown = false;
	componentMaximums = {
		static: {
			width: 1000,
			height: 1000
		},
		dynamic: {
			width: 600,
			height: 200
		}
	};
	maxHeight;
	maxWidth;

	@HostListener('window:resize', ['$event'])
	onResizeWindow(event) {
		this.comService.getTimerPopupPosition();
		this.formHeight = window.innerHeight - 170 + 'px';
	}

	constructor(
		private comService: ComponentService,
		private tz: TimezoneService,
		private fontsService: FontsService,
		private dateTime: DateTimeService,
		private sanitation: DomSanitizer,
		private filenamePipe: FilenamePipe,
		private auth: AuthService
	) {}

	ngOnInit() {
		this.maxHeight = this.componentData.config.personalized
			? this.componentMaximums.dynamic.height
			: this.componentMaximums.static.height;
		this.maxWidth = this.componentData.config.personalized ? this.componentMaximums.dynamic.width : this.componentMaximums.static.width;
		this.isAdmin = this.auth.isAdmin();
		if (this.componentData.config.version >= 3 && this.componentData.config.newapi) {
			this.componentData.config.personalized =
				typeof this.componentData.config.personalized === 'undefined' ? false : this.componentData.config.personalized;
			this.componentData.config.web_version =
				typeof this.componentData.config.web_version === 'undefined' ? false : this.componentData.config.web_version;
			this.newapi = true;
			for (const element of this.componentData.config.base.text.elements) {
				if (typeof element.letter_spacing === 'undefined') {
					element.letter_spacing = 0;
				}
			}
			for (const labelElement of this.componentData.config.labels.elements) {
				if (typeof labelElement.letter_spacing === 'undefined') {
					labelElement.letter_spacing = 0;
				}
			}
		}

		if (this.componentData.config.expired) {
			this.componentData.config.expired = false;
		}
		this.timezones = this.tz.getTimezones();
		this.background_type = this.componentData.config.base.background['background-image'] ? 'Image' : 'Color';

		if (this.background_type == 'Image') {
			this.imageWidth = Number(this.componentData.config.base.background['width']);
			this.imageHeight = Number(this.componentData.config.base.background['height']);
		}

		this.initDateTime();

		this.timeFormSubscription = this.timerForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave((this.timerForm.dirty && this.timerForm.invalid) || this.nameField.editComponentName)
				),
				filter((data) => Boolean(this.timerForm.dirty && this.timerForm.valid)),
				tap(() => {
					if (this.componentData.config.base.format === 'basic') {
						this.changeTopLeft();
					}
				})
			)
			.subscribe();

		this.timerPositionSubscription = this.comService.timerPopupPosition.subscribe((timerPosition) => {
			this.popUpTop = timerPosition.popUpTop;
			this.popUpLeft = timerPosition.popUpLeft;
		});

		this.date_format = this.componentData.config.base.text.format;

		this.fonts = this.fontsService.getFonts();
		this.font =
			this.fontsService.getFontsArray().indexOf(this.componentData.config.base.text.font) === -1
				? 'Custom Font'
				: this.componentData.config.base.text.font;

		if (this.newapi) {
			this.fontForLabel =
				this.fontsService.getFontsArray().indexOf(this.componentData.config.labels.font) === -1
					? 'Custom Font'
					: this.componentData.config.labels.font;
		}

		this.changeFont();

		this.expImageUrl =
			this.componentData.config.rules && this.componentData.config.rules.length
				? this.componentData.config.rules[0].background['background-image']
				: '';

		this.expLink =
			this.componentData.config.rules && this.componentData.config.rules.length ? this.componentData.config.rules[0].link : '';

		this.componentData.config.responsive = +this.componentData.config.responsive;
	}

	ngOnDestroy() {
		this.timeFormSubscription.unsubscribe();
		this.timerPositionSubscription.unsubscribe();
		this.date = null;
		clearInterval(this.interval);
	}

	initDateTime() {
		const tomorrow: Date = new Date();
		tomorrow.setDate(new Date().getDate() + 1);
		const currentTimeStamp: number = Math.floor(tomorrow.getTime() / 1000);
		const localOffset: number = new Date().getTimezoneOffset() * 60;
		const settingOffset: number = Number(this.componentData.config.timezone) * 60;
		this.date = this.time = new Date((this.componentData.config.timestamp + localOffset + settingOffset) * 1000);
		let newMaxdate = new Date((currentTimeStamp + localOffset + settingOffset) * 1000);
		this.minDate = new Date();
		this.maxDate = new Date(newMaxdate.getTime());
		this.minDate.setDate(this.minDate.getDate() - 1);
		this.maxDate.setDate(this.maxDate.getDate() + this.maxAllowedDays);
		this.timezone = this.componentData.config.timezone;
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewContent(this.getInstantViewer());
		this.comService.getTimerPopupPosition();
		this.stopCounting();
		this.jsCountDown();
	}

	resetBackground(type) {
		if (type == 'color') {
			this.componentData.config.base.background['base-background-image'] =
				this.componentData.config.base.background['background-image'];
			this.componentData.config.base.background['background-image'] = '';
		} else {
			this.componentData.config.base.background['background-image'] =
				this.componentData.config.base.background['base-background-image'];
			if (this.imageWidth) {
				this.componentData.config.base.background['width'] = this.imageWidth;
				this.componentData.config.base.background['height'] = this.imageHeight;
			}
		}
	}

	getInstantViewer(): string {
		const background: string =
			this.background_type === 'Image'
				? 'url(' + this.componentData.config.base.background['background-image'] + ') 50% 50% no-repeat'
				: this.componentData.config.base.background['background-color'];

		const style = `height: ${this.componentData.config.base.background.height}px;
             width: ${this.componentData.config.base.background.width}px;
             background: ${background};
             color: ${this.componentData.config.base.text.elements[0].color};
             font-size: ${this.componentData.config.base.text.elements[0]['font-size']}px;
             font-family: myFont${this.random};
             margin: 0 auto;
             text-align: left;
             position: relative;
             overflow:hidden;`;

		const linkStart: string = this.componentData.config.link ? `<a href="${this.componentData.config.link}" target="_blank">` : ``;
		const linkEnd: string = this.componentData.config.link ? `</a>` : ``;

		const template = `<style>
				@font-face {
					font-family: myFont${this.random};
					src: url('${this.componentData.config.base.text.font}');
				}
			</style>
            ${linkStart}<div style="${style}" id="countdown"></div>${linkEnd}`;
		return template;
	}

	onImageChange(event: any): void {
		const u = String(event && event.url);
		this.imageWidth = Number(event && event.width ? event.width : this.componentData.config.base.background['width']);
		this.imageHeight = Number(event && event.height ? event.height : this.componentData.config.base.background['height']);

		this.componentData.config.base.background['background-image'] = u;
		this.componentData.config.base.background['width'] = this.imageWidth;
		this.componentData.config.base.background['height'] = this.imageHeight;
	}

	onDateChange() {
		const localOffset: number = new Date().getTimezoneOffset() * 60;
		const settingOffset: number = Number(this.componentData.config.timezone) * 60;
		let fixing = Number(0);
		if (this.date.getTimezoneOffset() * 60 !== localOffset) {
			fixing = this.date.getTimezoneOffset() * 60 - localOffset;
		}

		const hours: number = this.time.getHours();
		const minutes: number = this.time.getMinutes();
		const seconds: number = this.time.getSeconds();
		this.date.setHours(hours, minutes, seconds);
		this.time = this.date;
		this.componentData.config.timestamp = this.date.getTime() / 1000 - localOffset - settingOffset - fixing;
	}

	onTimeChange() {
		if (!this.time) {
			return false;
		}
		const localOffset: number = new Date().getTimezoneOffset() * 60;
		const settingOffset: number = Number(this.componentData.config.timezone) * 60;
		let fixing = Number(0);
		if (this.time.getTimezoneOffset() * 60 !== localOffset) {
			fixing = this.time.getTimezoneOffset() * 60 - localOffset;
		}
		this.componentData.config.timestamp = this.time.getTime() / 1000 - localOffset - settingOffset - fixing;
	}

	onTimezoneChange(event) {
		const oldOffset: number = Number(this.componentData.config.timezone) * 60;
		const newOffset: number = Number(event) * 60;
		this.componentData.config.timestamp += oldOffset - newOffset;
		this.componentData.config.timezone = event;
	}

	stopCounting() {
		clearInterval(this.interval);
	}

	appendCountDownTimeLeft(timeLeft): string {
		let d, h, m, s;
		s = Math.floor(timeLeft / 1000);
		m = Math.floor(s / 60);
		s = s % 60;
		h = Math.floor(m / 60);
		m = m % 60;
		d = Math.floor(h / 24);
		h = h % 24;

		let text;
		if (this.componentData.config.base.text.format !== 'advanced') {
			if (this.newapi) {
				text = this.getBasicPosition();
			} else {
				text = this.componentData.config.base.text.elements[0].format;
			}
		} else {
			text = this.getTextPosition();
		}

		text = text.replace(
			'%d',
			this.newapi && d < 10 && this.componentData.config.base.text.elements[0].align == 'right'
				? `<span style="visibility:hidden">0</span>${d}`
				: d
		);
		text = text.replace('%D', this.dateTime.padDateTime(d, 2));
		text = text.replace(
			'%h',
			this.newapi && h < 10 && this.componentData.config.base.text.elements[1].align == 'right'
				? `<span style="visibility:hidden">0</span>${h}`
				: h
		);
		text = text.replace('%A', h + d * 24);
		text = text.replace('%H', this.dateTime.padDateTime(h, 2));
		text = text.replace(
			'%i',
			this.newapi && m < 10 && this.componentData.config.base.text.elements[2].align == 'right'
				? `<span style="visibility:hidden">0</span>${m}`
				: m
		);
		text = text.replace('%I', this.dateTime.padDateTime(m, 2));
		text = text.replace(
			'%s',
			this.newapi && s < 10 && this.componentData.config.base.text.elements[3].align == 'right'
				? `<span style="visibility:hidden">0</span>${s}`
				: s
		);
		text = text.replace('%S', this.dateTime.padDateTime(s, 2));

		return text;
	}

	countDownStop(): void {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	jsCountDown(): void {
		const countDownDomElem: HTMLElement = document.getElementById('countdown');
		if (!countDownDomElem) {
			this.countDownStop();
		}
		this.interval = window.setInterval(() => {
			const end: number = this.componentData.config.timestamp * 1000;
			const now: number = new Date().getTime();
			let timeLeft = Number(0);
			const localOffset: number = new Date().getTimezoneOffset() * 60;
			const settingOffset: number = Number(this.componentData.config.timezone) * 60;
			let fixing = Number(0);
			if (settingOffset !== localOffset) {
				fixing = settingOffset - localOffset;
			}

			if (end - now < 0 || !countDownDomElem) {
				clearInterval(this.interval);
			} else {
				timeLeft = end - now + localOffset + settingOffset + fixing;
			}

			if (countDownDomElem) {
				countDownDomElem.innerHTML = this.appendCountDownTimeLeft(timeLeft);
			}
			this.updateCountDownZoom(countDownDomElem);
		}, SECOND);
	}

	updateCountDownZoom(countDownDomElem: HTMLElement): void {
		const innerPreview = document.querySelectorAll('.innerPreview');
		if (innerPreview.length && this.isReponsive() && !this.componentData.config.web_version) {
			if (innerPreview[0].clientWidth / this.componentData.config.base.background.width > 1.25) {
				countDownDomElem.style.transform = `scale(1.25)`;
			} else {
				const clientWidth = innerPreview[0].clientWidth;
				const bgWidth = this.componentData.config.base.background.width;
				countDownDomElem.style.transform = `scale(${String(clientWidth / bgWidth)})`;
			}
		} else {
			countDownDomElem.style.transform = `scale(1)`;
		}
	}

	isReponsive(): boolean {
		return Boolean(this.componentData.config.responsive);
	}

	getBasicPosition(): string {
		return `<div style="color: ${this.componentData.config.base.text.basic.color};
    font-size: ${this.componentData.config.base.text.basic['font-size']}px;
    height: ${this.componentData.config.base.text.basic['font-size']}px;
    font-family: myFont${this.random};
    left: ${this.componentData.config.base.text.basic.left}px;
    top: ${this.componentData.config.base.text.basic.top - this.componentData.config.base.text.basic['font-size']}px;
    position: absolute;">
      ${this.componentData.config.base.text.format}
    </div>`;
	}

	getTextPosition(): string {
		let html = ``;
		for (let i = 0; i < this.componentData.config.base.text.elements.length; i++) {
			const letterSpacing = this.componentData.config.base.text.elements[i].letter_spacing
				? `letter-spacing:${this.componentData.config.base.text.elements[i].letter_spacing}px; `
				: '';
			const style = `
			color: ${this.componentData.config.base.text.elements[i].color};
			font-size: ${this.componentData.config.base.text.elements[i]['font-size']}px;
			height: ${this.componentData.config.base.text.elements[i]['font-size']}px;
			line-height: ${this.componentData.config.base.text.elements[i]['font-size']}px;
			font-family: myFont${this.random};
			${letterSpacing}
			left: ${this.componentData.config.base.text.elements[i].left}px;
			top: ${this.componentData.config.base.text.elements[i].top - this.componentData.config.base.text.elements[i]['font-size']}px;
			margin-top:${this.componentData.config.base.text.elements[i]['font-size'] / 11}px;
			position: absolute;
                `;

			const div = `<div style="${style}">
                    ${this.componentData.config.base.text.elements[i].format}
                   </div>`;

			html += div;
		}

		if (this.newapi && this.componentData.config.labels.include_labels) {
			for (let i = 0; i < this.componentData.config.labels.elements.length; i++) {
				const topCalculation = `${
					this.componentData.config.labels.elements[i].top - this.componentData.config.labels.elements[i]['font-size']
				}px`;
				const labelLetterSpacing = this.componentData.config.labels.elements[i].letter_spacing
					? `letter-spacing:${this.componentData.config.labels.elements[i].letter_spacing}px; `
					: '';
				const style = `
                      color: ${this.componentData.config.labels.elements[i].color};
                      font-size: ${this.componentData.config.labels.elements[i]['font-size']}px;
                      height: ${this.componentData.config.labels.elements[i]['font-size']}px;
                      font-family: myLabelFont${this.random};
					  ${labelLetterSpacing}
                      left: ${this.componentData.config.labels.elements[i].left}px;
                      top: ${topCalculation};
                      margin-top:${this.componentData.config.labels.elements[i]['font-size'] / 11}px;
                      position: absolute;
                  `;

				const div = `<div style="${style}">
                      ${this.componentData.config.labels.elements[i].text}
                     </div>`;

				html += div;
			}
		}

		return html;
	}

	expirationImageChange() {
		if (this.newapi) {
			if (this.expImageUrl !== '' && this.expImageUrl !== undefined) {
				this.componentData.config.expiration_image = this.expImageUrl;
			} else {
				this.componentData.config.expiration_image = '';
				this.componentData.config.expiration_link = '';
				this.expLink = '';
			}
		} else {
			if (this.expImageUrl !== '') {
				this.componentData.config.rules = [];
				this.componentData.config.rules.push(JSON.parse(JSON.stringify(this.componentData.config.base)));
				this.componentData.config.rules[0].timestamp = '-1s';
				this.componentData.config.rules[0].background['background-image'] = this.expImageUrl;

				for (let i = 0; i < this.componentData.config.rules[0].text.elements.length; i++) {
					this.componentData.config.rules[0].text.elements[i].format = '';
				}
			} else {
				this.componentData.config.rules = [];
				this.expLink = '';
			}
		}
	}

	expLinkChange() {
		if (this.newapi) {
			this.componentData.config.expiration_link = this.expLink;
		} else {
			this.componentData.config.rules[0].link = this.expLink;
		}
	}

	processReturnedData(event) {
		switch (event.method) {
			case 'updatePosition':
				if (this.componentData.config.horizontal_lock) {
					for (let i = 0; i < this.componentData.config.base.text.elements.length; i++) {
						this.componentData.config.base.text.elements[i].top = event.data.top;
					}
					this.componentData.config.base.text.elements[event.element].left = event.data.left;
				} else if (this.componentData.config.vertical_lock) {
					for (let i = 0; i < this.componentData.config.base.text.elements.length; i++) {
						this.componentData.config.base.text.elements[i].left = event.data.left;
					}
					this.componentData.config.base.text.elements[event.element].top = event.data.top;
				} else {
					this.componentData.config.base.text.elements[event.element].top = event.data.top;
					this.componentData.config.base.text.elements[event.element].left = event.data.left;
				}
				break;

			case 'updateLabelPosition':
				if (this.componentData.config.horizontal_lock) {
					for (let i = 0; i < this.componentData.config.labels.elements.length; i++) {
						this.componentData.config.labels.elements[i].top = event.data.top;
					}
					this.componentData.config.labels.elements[event.element].left = event.data.left;
				} else if (this.componentData.config.vertical_lock) {
					for (let i = 0; i < this.componentData.config.labels.elements.length; i++) {
						this.componentData.config.labels.elements[i].left = event.data.left;
					}
					this.componentData.config.labels.elements[event.element].top = event.data.top;
				} else {
					this.componentData.config.labels.elements[event.element].top = event.data.top;
					this.componentData.config.labels.elements[event.element].left = event.data.left;
				}
				break;

			case 'updateBasicPosition':
				this.componentData.config.base.text.basic.top = event.data.top;
				this.componentData.config.base.text.basic.left = event.data.left;
				break;

			case 'savePositions':
				this.brodcastToPreview();
				this.isModalShown = false;
				break;

			case 'cancelBasic':
				this.componentData.config.base.text.basic = event.data;
				this.isModalShown = false;
				break;

			case 'cancel':
				for (let i = 0; i < this.componentData.config.base.text.elements.length; i++) {
					this.componentData.config.base.text.elements[i].format = event.data[i][0];
					this.componentData.config.base.text.elements[i].color = event.data[i][1];
					this.componentData.config.base.text.elements[i]['font-size'] = event.data[i][2];
					this.componentData.config.base.text.elements[i].left = event.data[i][3];
					this.componentData.config.base.text.elements[i].top = event.data[i][4];
					this.componentData.config.base.text.elements[i].align = event.data[i][5];
				}
				if (this.componentData.config.labels.include_labels) {
					for (let i = 0; i < this.componentData.config.labels.elements.length; i++) {
						this.componentData.config.labels.elements[i].color = event.labels[i][2];
						this.componentData.config.labels.elements[i]['font-size'] = event.labels[i][3];
						this.componentData.config.labels.elements[i].top = event.labels[i][4];
						this.componentData.config.labels.elements[i].left = event.labels[i][5];
					}
				}
				this.isModalShown = false;
				break;
		}
	}

	changeDateFormat(format) {
		if (this.newapi) {
			this.componentData.config.base.text.format = format;
			if (format != 'advanced') {
				this.componentData.config.labels.include_labels = false;
			}
		} else {
			if (format === 'advanced') {
				this.componentData.config.base.text.elements[0].format = '%D';
				this.componentData.config.base.text.elements[1].format = '%H';
				this.componentData.config.base.text.elements[2].format = '%I';
				this.componentData.config.base.text.elements[3].format = '%S';
				this.componentData.config.base.text.elements[0].top = this.componentData.config.base.text.elements[1].top;
				this.componentData.config.base.format = 'advanced';
			} else {
				this.changeTopLeft();

				this.componentData.config.base.text.elements[0].format = format;
				this.componentData.config.base.text.elements[1].format = null;
				this.componentData.config.base.text.elements[2].format = null;
				this.componentData.config.base.text.elements[3].format = null;
				this.componentData.config.base.format = 'basic';
			}
		}
	}

	changeTopLeft() {
		this.componentData.config.base.text.elements[0].top =
			+this.componentData.config.base.text.top + +this.componentData.config.base.text.elements[0]['font-size'] + 3;

		this.componentData.config.base.text.elements[0].left = this.componentData.config.base.text.left;
	}

	hide(elm) {
		setTimeout(() => {
			elm.hide();
		}, 0);
	}

	onFontSizeChange(event) {
		this.componentData.config.base.text.elements[0]['font-size'] = event;

		if (this.componentData.config.base.format === 'basic') {
			this.changeTopLeft();
		}
	}

	onElementScroll(event) {
		this.formScrollProp = {
			scrollTop: event.target.scrollTop || 0,
			scrollHeight: event.target.scrollHeight || 0,
			clientHeight: event.target.clientHeight || 0,
			offset: event.target.scrollHeight - event.target.clientHeight
		};
	}

	labelChange() {
		if (this.componentData.config.labels.include_labels) {
			this.changeFont();
		}
	}

	changeFont(): void {
		let fontForLabel = '';
		this.random = Math.floor(Math.random() * 1000 + 1);
		if (this.newapi && this.componentData.config.labels.include_labels) {
			fontForLabel = `
      @font-face {
        font-family: 'myLabelFont${this.random}';
        src: url('${this.componentData.config.labels.font}');
      }`;
		}
		const fontName = this.filenamePipe.transform(this.componentData.config.base.text.font);
		this.componentData.fontName = this.sanitation.bypassSecurityTrustStyle(`'` + fontName.substr(0, fontName.length - 4) + `'`);
		const css = `
                  <style>
                    @font-face {
                    font-family: 'myFont${this.random}';
                    src: url('${this.componentData.config.base.text.font}');
                  }
                  ${fontForLabel}
                  </style>`;
		const container = document.getElementById('timerFontStyleContainer');
		const style = document.createElement('style');
		style.appendChild(document.createTextNode(css));
		container.innerHTML = css;
	}

	showAdvanced() {
		this.brodcastToPreview();
	}

	checkiOSLink() {
		if (!this.componentData.config.ios_privacy_fallback || this.componentData.config.ios_privacy_fallback == '') {
			this.componentData.config.ios_privacy_fallback_link = '';
			this.componentData.config.ios_privacy_fallback = '';
		}
	}

	separatorChange(type) {
		if (this.newapi && this.componentData.config.include_separators) {
			let space = 60;
			if (type == 'include') {
				for (let i = 0; i < this.componentData.config.separator_amount; i++) {
					this.componentData.config.base.text.elements.push({
						format: this.componentData.config.separator_text,
						color: '#FFFFFF',
						'font-size': 32,
						left: 92 + space * i,
						top: 95,
						align: 'left',
						letter_spacing: 0
					});
				}
			} else if (type == 'text') {
				for (let i = 0; i < this.componentData.config.separator_amount; i++) {
					this.componentData.config.base.text.elements[i + 4].format = this.componentData.config.separator_text;
				}
			} else if (type == 'amount') {
				if (this.componentData.config.base.text.elements.length > 4 + parseInt(this.componentData.config.separator_amount)) {
					this.componentData.config.base.text.elements = this.componentData.config.base.text.elements.slice(
						0,
						4 + parseInt(this.componentData.config.separator_amount)
					);
				} else {
					for (
						let i = this.componentData.config.base.text.elements.length;
						i < parseInt(this.componentData.config.separator_amount) + 4;
						i++
					) {
						this.componentData.config.base.text.elements.push({
							format: this.componentData.config.separator_text,
							color: '#FFFFFF',
							'font-size': 32,
							left: this.componentData.config.base.text.elements[i - 1].left + space,
							top: this.componentData.config.base.text.elements[i - 1].top,
							align: 'left',
							letter_spacing: 0
						});
					}
				}
			}
			this.brodcastToPreview();
		} else {
			this.componentData.config.base.text.elements = this.componentData.config.base.text.elements.slice(0, 4);
			this.brodcastToPreview();
		}
	}

	createPersonalizedTimer() {
		this.componentData.config.personalized_options = {
			type:
				this.componentData.config.personalized_options && this.componentData.config.personalized_options.type
					? this.componentData.config.personalized_options.type
					: 'mergeTag',
			time_from_open:
				this.componentData.config.personalized_options && this.componentData.config.personalized_options.time_from_open
					? this.componentData.config.personalized_options.time_from_open
					: '',
			merge_tag:
				this.componentData.config.personalized_options && this.componentData.config.personalized_options.merge_tag
					? this.componentData.config.personalized_options.merge_tag
					: '',
			personalized_merge_tag_format:
				this.componentData.config.personalized_options &&
				this.componentData.config.personalized_options.personalized_merge_tag_format
					? this.componentData.config.personalized_options.personalized_merge_tag_format
					: this.standardDateFormat,
			fallback_type:
				this.componentData.config.personalized_options && this.componentData.config.personalized_options.fallback_type
					? this.componentData.config.personalized_options.fallback_type
					: 'collapse',
			fallback_image:
				this.componentData.config.personalized_options && this.componentData.config.personalized_options.fallback_image
					? this.componentData.config.personalized_options.fallback_image
					: '',
			fallback_cta:
				this.componentData.config.personalized_options && this.componentData.config.personalized_options.fallback_cta
					? this.componentData.config.personalized_options.fallback_cta
					: ''
		};
		this.componentData.config.web_version = false;
		this.changeDateFormat('advanced');
		this.date_format = 'advanced';
		this.resetBackground('color');
		this.background_type = 'Color';
		this.maxHeight = this.componentMaximums.dynamic.height;
		this.maxWidth = this.componentMaximums.dynamic.width;
		if (!this.componentData.config.dm_params) {
			this.componentData.config.dm_params = DM_PARAMS_DEFAULT;
		}
	}

	createWebBasedTimer() {
		this.changeDateFormat('advanced');
		this.date_format = 'advanced';
	}

	setStaticTimer() {
		this.maxHeight = this.componentMaximums.static.height;
		this.maxWidth = this.componentMaximums.static.width;
	}
}
